import React from "react";

import  IntOutBoundFileDetail from "../component/IntOutBoundFileDetail";

const IntOutBoundFileDetailContainer = ({ pageId }) => (<IntOutBoundFileDetail pageId = {pageId}/>)

export default IntOutBoundFileDetailContainer;